// import { Stack } from "@mui/material";

// import { categories } from "../utils/Contants";

// const Sidebar = ({ selectedCategory, setSelectedCategory }) => {
//   return (
//     <Stack
//       sx={{
//         overflowY: "auto",
//         height: { sx: "auto", md: "95%" },
//         flexDirection: { md: "column" },
//       }}
//     >
//       {categories.map((category) => (
//         <button
//           className="category-btn"
//           onClick={() => setSelectedCategory(category.name)}
//           style={{
//             background: category.name === selectedCategory && "#FC1503",
//             color: "white",
//           }}
//           key={category.name}
//         >
//           <span
//             style={{
//               color: category.name === selectedCategory ? "white" : "red",
//               marginRight: "15px",
//             }}
//           >
//             {category.icon}
//           </span>
//           <span
//             style={{
//               opacity: category.name === selectedCategory ? "1" : "0.8",
//             }}
//           >
//             {category.name}
//           </span>
//         </button>
//       ))}
//     </Stack>
//   );
// };

// export default Sidebar;

import { Stack } from "@mui/material";
import { categories } from "../utils/Contants";
// import { categories } from "../utils/Constants";

const Sidebar = ({ selectedCategory, setSelectedCategory }) => {
  return (
    <Stack
      sx={{
        overflowY: "auto",
        height: { xs: "auto", md: "95%" }, // Adjust height for small and medium devices
        flexDirection: { xs: "row", md: "column" }, // Stack items horizontally on small screens
        justifyContent: { xs: "space-between", md: "start" }, // Space buttons evenly on small screens
      }}
    >
      {categories.map((category) => (
        <button
          className="category-btn"
          onClick={() => setSelectedCategory(category.name)}
          style={{
            background: category.name === selectedCategory && "#FC1503",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            padding: "10px 15px",
            borderRadius: "5px",
            marginBottom: "10px",
            flexGrow: { xs: 1, md: 0 }, // Flex grow on small screens to take up available space
          }}
          key={category.name}
        >
          <span
            style={{
              color: category.name === selectedCategory ? "white" : "red",
              marginRight: "15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {category.icon}
          </span>
          <span
            style={{
              opacity: category.name === selectedCategory ? "1" : "0.8",
            }}
          >
            {category.name}
          </span>
        </button>
      ))}
    </Stack>
  );
};

export default Sidebar;
